import { faMagicWandSparkles, faMobileAndroidAlt, faMobilePhone } from "@fortawesome/free-solid-svg-icons";
import { MotionFrame } from "../utilities/framer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const MobileStack = ({
    stack
}) => {
    return (
        <MotionFrame>
            <div className="stack glassy-effect">
                <div className="top-ico">
                    <FontAwesomeIcon icon={faMobileAndroidAlt} color="#420667ff" />
                </div>
                <div className="stack-nm">{stack}</div>
            </div>
        </MotionFrame>
    );
}

export const GraphicStack = ({ stack }) => {
    return (
        <MotionFrame>
            <div className="stack glassy-effect">
                <div className="top-ico">
                    <FontAwesomeIcon icon={faMagicWandSparkles} color="#17b365ff" />
                </div>
                <div className="stack-nm">{stack}</div>
            </div>
        </MotionFrame>
    );
}